<script setup lang="ts">
import CreateBillItems from '@/views/AdminDashboard/Billing/CreateBillItems.vue';
import RecordManualPayment from '@/views/AdminDashboard/Billing/RecordManualPayment.vue';
import { useGeneralModalStore } from '@/store/general-modal-store';

const { allModals, toggleModalByName } = useGeneralModalStore();
</script>

<template>
    <Dialog v-model:visible="allModals.showCreateBillItemsDialog" header="Create Bill Items" :modal="true" :closable="false" :style="{ width: '44vw' }">
        <CreateBillItems @close="toggleModalByName('showCreateBillItemsDialog')" />
    </Dialog>
    <Dialog v-model:visible="allModals.showRecordManualPaymentDialog" header="Record Manual Payment" :modal="true" :closable="true" :style="{ width: '44vw' }">
        <RecordManualPayment @close="toggleModalByName('showRecordManualPaymentDialog')" />
    </Dialog>
</template>

